import { useQuery } from "@tanstack/react-query";

import { apiLongRunningRequestTimeoutMs } from "../config";
import useApiHelper from "../hooks/useApiHelper";
import { IStationOverTargetResponse } from "../models/ProductionDashboard";

/**
 * Time over target per station, split by dismantling line, over a date range.
 *
 * Its own query rather than a field on useStationCycleTimes: the Performance page drives it from
 * the range picker it already has, and nothing else on that page needs the cycle-time medians.
 */
export default function useStationOverTarget(from: string, to: string, enabled = true) {
  const { get } = useApiHelper({ timeoutMs: apiLongRunningRequestTimeoutMs });

  return useQuery({
    queryKey: ["stationOverTarget", from, to],
    queryFn: () =>
      get<IStationOverTargetResponse>(
        `/productionmanager/cycle-times/over-target?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
      ),
    staleTime: 1000 * 60 * 1,
    enabled: enabled && !!from && !!to,
    retry: 1,
  });
}
